import clsx from 'clsx';
import { FC } from 'react';

import { BasicModal } from 'src/general/components/BasicModal/BasicModal';
import { Button } from 'src/general/components/Button/Button';

import styles from './CheckoutConfirmPopup.module.scss';

interface Props {
  isOpen: boolean;
  onClose: () => void;
  onChange: () => void;
  isLoading?: boolean;
}

export const CheckoutConfirmPopup: FC<Props> = ({ isOpen, onClose, onChange, isLoading }) => (
  <BasicModal id="change-payment" title="Changing your payment option" isOpen={isOpen} className={styles.root}>
    Not interested in paying with finance? Continue to complete your checkout by using your own funds.
    <footer className={styles.footer}>
      <Button
        onClick={onClose}
        data-testid="CheckoutConfirmPopup-component-backButton"
        className={clsx(styles.btn, styles.btnGoBack)}
        variant="tertiary"
        disabled={isLoading}
      >
        Go back
      </Button>
      <Button
        onClick={onChange}
        data-testid="CheckoutConfirmPopup-component-continueButton"
        className={clsx(styles.btn, styles.btnContinue)}
        variant="primary"
        isLoading={isLoading}
      >
        Continue
      </Button>
    </footer>
  </BasicModal>
);
